import styled from "styled-components";

export const Header = styled.h3`
  color: rgba(16, 15, 87, 0.49);
  font-size: 12px;
  font-weight: bold;
`;

export const UsersContainer = styled.div`
  margin: 5.6rem 3rem 0 3rem;
  .margin-top-container {
    margin-top: 3.2rem;
  }
`;

export const DivFormBetween = styled.div`
  .div-flex-between {
    display: flex;
    justify-content: space-between;
  }
  .create-user-div {
    color: #2e353d;
  }
  .margin-top-form {
    margin-top: 2.4rem;
  }
  .div-margin-top {
    margin-top: 3.2rem;
  }
  .div-margin-left {
    margin-left: 2rem;
  }
`;
export const DivDataUser = styled.div`
  color: #2e353d;
  font-size: 1.4rem;
  margin-top: 3.6rem;
`;

export const DivFormStyles = styled.div`
  ${(props) => `
        color: ${props.theme.colors.blackTextTitle};
        font-family: ${props.theme.fontFamilies.primaryFont};
    `}

  .p-dropdown-panel .p-dropdown-items {
    font-size: 1.4rem;
    padding: 0.5rem 0;
  }
  .inputForms
    .input-styles-users
    .p-multiselect-label-container
    .p-multiselect-label
    .p-multiselect-token {
    background: rgba(23, 21, 120, 0.1);
    border-radius: 8px;
  }

  .inputForms {
    display: flex;
    flex-direction: column;
  }
  .inputForms label {
    font-size: 1.4rem;
  }
  .border-radio-input {
    border-radius: 2rem;
  }
  .width-input-multiselect {
    font-family: Montserrat;
    margin-left: 2rem;
    width: 53.2rem;
  }
  .width-input-font {
    width: 34.8rem;
    font-family: Montserrat;
  }

  .inputForms .input-styles-users {
    border-radius: 0.8rem;
    box-shadow: 0rem 0.5rem 2rem rgba(231, 231, 234, 0.62);
    box-sizing: border-box;
    font-family: Montserrat;
    font-size: 1.4rem;
    font-size: 1.5rem;
    font-weight: 500;
    height: 5rem;
    margin-top: 1rem;
    padding-left: 1.5rem;
    ::-webkit-outer-spin-button,
    ::-webkit-inner-spin-button {
      -webkit-appearance: none;
      margin: 0;
    }
  }
  .inputForms .input-with-multi-select {
    alignitems: center;
    display: flex;
    fontfamily: Montserrat;
    height: 5rem;
    width: 44rem;
  }

  .inputForms .p-dropdown:not(.p-disabled):hover {
    border-color: #002e6c;
  }
  .inputForms .p-dropdown:not(.p-disabled).p-focus {
    border-color: #002e6c;
  }

  .inputForms .input-styles-users11 {
    align-items: center;
    border-radius: 0.8rem;
    display: flex;
    font-family: Montserrat;
    font-size: 1.4rem;
    height: 5rem;
    margin-top: 1rem;

    ::-webkit-outer-spin-button,
    ::-webkit-inner-spin-button {
      -webkit-appearance: none;
      margin: 0;
    }
  }

  .inputForms .width-column-two {
    width: 25.6rem;
    border: 1px solid #ffffff;
  }
  .inputForms .p-dropdown {
    border: 1px solid #ffffff;
  }

  .inputForms .width-column-one {
    width: 34.5rem;
  }
  .inputForms .width-column-one-part {
    width: 16.4rem;
  }
  .inputForms .width-user-name {
    align-items: center;
    display: flex;
    width: 53.2rem;
  }

  .inputForms .input-styles-users1 {
    align-items: center;
    display: flex;
    height: 5rem;
    justify-content: center;
    margin-top: 1rem;
    width: 25rem;
  }
  .inputForms .input-styles-users1 .p-dropdown-label {
    color: #08082b;
    font-size: 1.4rem;
  }
  .inputForms .p-inputtext {
    border-radius: 8px;
    border: 0rem;
    color: #2e353d;
    font-size: 1.4rem;
    font-style: normal;
    font-weight: 500;
    line-height: 1.7rem;
  }
  .inputForms .p-inputtext.p-invalid {
    border: 1rem solid #f44336;
  }
  .inputForms label {
    color: #2e353d;
    font-size: 1.4rem;
    font-style: normal;
    font-weight: 500;
    line-height: 1.7rem;
  }

  .input-width {
    width: 34.8rem;
    height: 5rem;
  }
  .inputForms .multiselect-width-profile {
    align-items: center;
    display: flex;
    font-family: Montserrat;
    height: 5rem;
    width: 44rem;
  }
  .inputForms .multiselect-width-type-profile {
    align-items: center;
    display: flex;
    font-family: Montserrat;
    height: 5rem;
    width: 34.8rem;
  }
`;

interface ISearchButtonFilter {
  background?: string;
  isLoading?: any;
  height?: string;
  width?: string;
}
export const SearchButtonFilter = styled.button<ISearchButtonFilter>`
  ${(props) => `
    background-color: ${
      props.background === "blue"
        ? props.theme.colors.primaryBlue
        : props.background === "white"
        ? "#FFFFFF"
        : props.theme.colors.accentGreen
    };
    color: ${
      props.background === "white" ? "#2E353D" : props.theme.colors.white
    };
    cursor: ${props.isLoading ? "default" : "pointer"};
    font-family: ${props.theme.fontFamilies.primaryFont};
    height: ${props.height ? props.height : "5rem"};
    width: ${props.width ? props.width : "25.6rem"};
  `}
  align-items: center;
  border-radius: 0.8rem;
  border: none;
  display: flex;
  font-size: 1.6rem;
  font-weight: 700;
  justify-content: center;
  margin-left: 0.5rem;

  .icon-vector-img {
    height: 1.5rem;
    width: 1rem;
  }
  .icon {
    height: 5rem;
    width: 5rem;
  }
  .icon-excel {
    height: 2.4rem;
    width: 2.4rem;
    margin-right: 1rem;
  }
`;
interface IButtonDocument {
  background?: string;
  isLoading?: any;
  height?: string;
  width?: string;
}
export const ButtonDocument = styled.button<IButtonDocument>`
  ${(props) => `
    background-color: ${
      props.background ? props.background : props.theme.colors.primaryBlue
    };
    color: ${props.color ? props.color : "#08082B"};
    cursor: ${props.isLoading ? "default" : "pointer"};
    font-family: ${props.theme.fontFamilies.primaryFont};
    height: ${props.height ? props.height : "5rem"};
    width: ${props.width ? props.width : "25.6rem"};
  `}
  align-items: center;
  border-radius: 0.8rem;
  border-style: dashed;
  display: flex;
  font-size: 1.2rem;
  font-weight: 500;
  justify-content: center;
  margin-left: 0.5rem;

  .icon-vector-img {
    height: 1.5rem;
    width: 1rem;
  }
  .icon {
    height: 2.4rem;
    margin-right: 0.8rem;
    width: 2.4rem;
  }
`;

interface IInputElement {
  hasError?: any;
  disableOutline?: any;
}
export const InputElement = styled.input<IInputElement>`
  ${(props) => `
    border: ${
      props.hasError ? "solid 1px " + props.theme.colors.accentRed : "none"
    };
    color: ${props.theme.colors.blackTextTitle};
    font-family: ${props.theme.fontFamilies.primaryFont};
    height: ${props.height ? props.height : "4.5rem"};
    outline: ${props.disableOutline ? "none" : ""};
    width: ${props.width};
  `}

  border-radius: 0.8rem;
  box-shadow: 0rem 0.5rem 2rem rgba(231, 231, 234, 0.62);
  box-sizing: border-box;
  font-size: 1.5rem;
  font-weight: 500;
  padding-left: 1.5rem;

  ::-webkit-outer-spin-button,
  ::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }
  ::placeholder {
    color: ${(props) => props.theme.colors.gray72};
  }
`;

export const VolanteId = styled.div`
  ${(props) => `
    color: ${props.theme.colors.primaryBlue};
    font-family: ${props.theme.fontFamilies.primaryFont};
  `}
  font-size: 1.4rem;
  font-weight: 600;
`;

export const DivTable = styled.div`
  ${(props) => `
    font-family: ${props.theme.fontFamilies.primaryFont};
  `}
  .tableSearch .TableBody tr.trBody {
    background: #ffffff;
    border-radius: 8px;
    box-shadow: 0rem 0.5rem 2rem rgba(231, 231, 234, 0.62);
    height: 8.3rem;
  }
  .tableSearch thead th {
    color: #989ca2;
    font-size: 1.2rem;
    font-style: normal;
    font-weight: bold;
    line-height: 1.5rem;
  }
  .tableSearch .TableBody tr.trBody td {
    border: hidden;
    color: #08082b;
    font-size: 1.4rem;
    font-style: normal;
    font-weight: 500;
    line-height: 1.7rem;
  }
  .tableSearch .TableBody tr.trBody .ellipsis-text {
    overflow: hidden;
  }
  .tableSeparate {
    border-collapse: separate !important;
    border-spacing: 0 0.8rem;
  }
  .tableSearch .between-flex {
    display: flex;
    justify-content: space-between;
  }

  .width-flex-left {
    display: flex;
    margin-left: 2rem;
    width: 100%;
  }
  .width-left {
    margin-left: 2rem;
    width: 100%;
  }
  .tableSearch .between-flex-center {
    align-items: center;
    display: flex;
    justify-content: space-between;
  }

  .width-flex {
    display: flex;
    width: 100%;
  }
  .column-direction {
    display: flex;
    flex-direction: column;
  }
  .margin-top-2 {
    margin-top: 0.2rem;
  }
  .margin-color-2 {
    color: #989ca2;
    margin-top: 0.2rem;
  }
  .font-weight-line {
    color: #08082b;
    font-size: 1.4rem;
    font-weight: 600;
    line-height: 2rem;
  }
  .flex-with-rem {
    display: flex;
    justify-content: flex-end;
    margin-right: 2rem;
  }
  .table-margin-top {
    margin-top: 3.2rem;
    width: 100%;
  }

  .flex-en-right {
    display: flex;
    justify-content: flex-end;
    margin-right: 2rem;
  }
`;

export const DivFleDirection = styled.div`
  display: flex;
  flex-direction: column;
`;

export const DivMarginTop = styled.div`
  display: flex;
  justify-content: space-between;
  margin-top: 3.2rem;
  align-items: center;
  .justify-end-div {
    display: flex;
    justify-content: flex-end;
  }
`;

export const DivPaginator = styled.div`
  ${(props) => `
    
    font-family: ${props.theme.fontFamilies.primaryFont};
    background: ${props.theme.colors.primaryBlue};
  `}
  color: #FFFFFF;
  font-size: 1.5rem;
`;

export const Container = styled.div`
  background-color: white;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  height: 100vh;
  padding: 5rem 3.2rem 1.2rem;
  width: 116.8rem;

  .header {
    flex-shrink: 0;
    order: 1;
  }
  .content {
    order: 2;
    overflow-y: auto;
    scrollbar-width: none;
    -ms-overflow-style: none;
    ::-webkit-scrollbar {
      display: none;
    }
  }
  .footer {
    flex-shrink: 0;
    order: 3;

    .block-hint {
      color: ${(props) => props.theme.colors.red};
      font-size: 1.4rem;
      text-align: center;
    }
  }

  .clickable-element {
    cursor: pointer;
  }
`;

export const DivCompany = styled.div`
  color: #2e353d;
  font-size: 1.4rem;
  margin-top: 4rem;
`;

export const ContentDiv = styled.div`
  align-items: center;
  display: grid;
  font-family: Montserrat;
  font-size: 1.3rem;
  grid-template-columns: 1fr 13rem 13rem;
  justify-content: space-between;
  margin-left: 1.1rem;
  margin-right: 1.1rem;

  .option-flex-align {
    align-items: center;
    display: flex;
    width: 20rem;
  }
`;

export const DivFlexCenter = styled.div`
  display: flex;
  justify-content: center;
`;

export const DivLine = styled.div`
  background: rgba(231, 231, 234, 0.74);
  height: 1px;
  margin-top: 1.6rem;
  width: 28.2rem;
`;

interface IButton {
  status?: string;
}
export const Button = styled.button<IButton>`
  ${(props) => `
    background-color: ${
      props.status === "accept"
        ? props.theme.colors.primaryBlue
        : props.status === "confirm"
        ? props.theme.colors.accentRed
        : props.theme.colors.white
    };
    border: ${
      props.status === "cancel"
        ? `1px solid ${props.theme.colors.accentRed}`
        : "none"
    };
    color: ${
      props.status === "cancel"
        ? props.theme.colors.accentRed
        : props.theme.colors.white
    };
    font-family: ${props.theme.fontFamilies.primaryFont};
  `}
  align-items: center;
  border-radius: 8px;
  cursor: pointer;
  display: flex;
  font-size: 1.5rem;
  font-weight: 700;
  height: 5rem;
  justify-content: center;
  margin-top: 1rem;
  width: 100%;
  &:disabled,
  &[disabled] {
    cursor: not-allowed;
  }

  .icon {
    height: 5rem;
    width: 5rem;
  }
`;

export const Container1 = styled.div`
  align-items: center;
  background-color: ${(props) => props.theme.colors.white};
  border-radius: 10px;
  display: flex;
  flex-direction: column;
  gap: 1rem;
  justify-content: center;
  min-height: 23rem;
  padding: 4rem 5rem;
  text-align: center;
  width: 40rem;

  h1 {
    ${(props) => `
      color: ${props.theme.colors.blackTextBody};
      font-family: ${props.theme.fontFamilies.primaryFont};
    `}
    font-size: 2rem;
    font-weight: bold;
    margin-bottom: 0;
  }

  .button-container {
    width: 100%;
  }

  .description {
    ${(props) => `
      color: ${props.theme.colors.gray};
    `}
    font-size: 1.5rem;
  }

  .icon {
    height: 6rem;
    margin: 1rem;
    width: 6rem;
  }
`;

interface IMainButton {
  background?: string;
}
export const MainButton = styled.button<IMainButton>`
  ${(props) => `
  background-color: ${
    props.background === "blue"
      ? props.theme.colors.primaryBlue
      : props.theme.colors.accentGreen
  };
  font-family: ${props.theme.fontFamilies.primaryFont};
`}
  align-items: center;
  border-radius: 8px;
  border: none;
  color: ${(props) => props.theme.colors.white};
  cursor: pointer;
  display: flex;
  font-size: 1.6rem;
  font-weight: 700;
  height: 4rem;
  justify-content: center;
  min-height: 6.4rem;
  width: 27.8rem;
  .icon {
    height: 5rem;
    width: 5rem;
    margin-left: 1rem;
  }
  .icon-right {
    height: 1.2rem;
    width: 0.8rem;
    margin-left: 1rem;
  }
`;

export const Headers = styled.div`
  display: flex;
  justify-content: space-between;
`;

export const MainContainer = styled.div`
  padding-top: 3rem;
`;

export const DivjustifyAlign = styled.div`
  align-items: center;
  display: flex;
  justify-content: space-between;
  margin-top: 2.4rem;
`;
interface IDivFlex {
  width?: string;
}
export const DivFlex = styled.div<IDivFlex>`
  ${(props) => `
    width: ${props.width ? props.width : "25.6rem"};
    `}
  display: flex;
  justify-content: end;
  position: absolute;
`;
export const DivDocumentUpload = styled.div`
  display: flex;
  flex-direction: column;
  font-family: Montserrat;
  margin-left: 1.5rem;
  .document-title {
    margin-left: 0.5rem;
    font-size: 1.4rem;
  }
  .margin-top1 {
    margin-top: 1rem;
  }
  .max-mb-document {
    margin-top: 0.8rem;
    margin-left: 0.5rem;
    font-size: 1.2rem;
  }
`;

interface IDivUserType {
  typeUser?: string;
}
export const DivUserType = styled.div<IDivUserType>`
  ${(props) => `
      color: ${props.typeUser === "Administrador" ? "#989CA2" : "#000000"};
    `}
  margin-left: 1.4rem;
  font-size: 1.4rem;
  font-family: Montserrat;
`;

export const ContainerUploadFile = styled.div`
  background-color: ${(props) => props.theme.colors.white};
  font-family: ${(props) => props.theme.fontFamilies.primaryFont};
  align-items: center;
  border-radius: 10px;
  display: flex;
  flex-direction: column;
  max-height: 80vh;
  overflow-y: scroll;
  padding: 5rem 7rem;
  scrollbar-width: none;
  width: 70rem;

  -ms-overflow-style: none;
  ::-webkit-scrollbar {
    display: none;
  }

  h1 {
    ${(props) => `
      color: ${props.theme.colors.blackTextBody};
    `}
    font-size: 2rem;
    font-weight: 800;
    margin-bottom: 3rem;
    margin-top: 0;
  }
`;

export const MainButtonFile = styled.button`
  ${(props) => `
    background-color: ${props.theme.colors.accentGreen};
    color: ${props.theme.colors.white};
    font-family: ${props.theme.fontFamilies.primaryFont};
  `}
  align-items: center;
  border-radius: 8px;
  border: none;
  cursor: pointer;
  display: flex;
  font-size: 1.7rem;
  font-weight: 700;
  justify-content: center;
  margin-top: 4rem;
  min-height: 5.8rem;
  width: 30rem;

  &:disabled,
  &[disabled] {
    background-color: ${(props) =>
      props.theme.colors.accentGreen + props.theme.transparencies.p20};
  }

  .icon {
    height: 5rem;
    width: 5rem;
  }
`;

export const FileInfo = styled.div`
  align-items: center;
  border-color: transparent;
  border-radius: 8px;
  border: none;
  box-shadow: 0px 5px 20px rgb(231 231 234 / 62%);
  display: flex;
  font-size: 1.4rem;
  font-weight: 600;
  justify-content: space-between;
  padding: 0 1rem;

  .delete-icon {
    filter: invert(0%) sepia(0%) saturate(0%) hue-rotate(106deg) brightness(30%)
      contrast(105%);
  }

  p {
    margin-left: 1rem;
  }
  .size {
    color: ${(props) => props.theme.colors.gray72};
    font-weight: 500;
  }
`;

interface IRowContainer {
  height?: string;
  width?: string;
}
export const RowContainer = styled.div<IRowContainer>`
  border-radius: 8px;
  border: 2px dashed #002e6c;
  cursor: pointer;
  height: ${(props) => (props.height ? props.height : "5rem")};
  width: ${(props) => (props.width ? props.width : "25rem")};
  p {
    font-family: ${(props) => props.theme.fontFamilies.primaryFont};
    font-size: 1.4rem;
  }
  img {
    padding: 0.5rem;
  }
  display: flex;
  align-items: center;
`;

export const DashedRow = styled.div`
  align-items: center;
  color: ${(props) => props.theme.colors.blackTextTitle};
  display: flex;
  font-family: ${(props) => props.theme.fontFamilies.primaryFont};
  font-size: 1.2rem;
  font-weight: 500;
  padding: 3rem 0;
  row-gap: 0.8rem;
  text-align: center;
`;

export const LabelStyleText = styled.div`
  font-family: ${(props) => props.theme.fontFamilies.primaryFont};
  font-style: normal;
  font-weight: normal;
  font-size: 1.3rem;
  line-height: 2rem;
  display: flex;
  align-items: center;
  color: #000000;
`;

interface ILabelText {
  positions?: any;
  left?: any;
  width?: any;
  leftBefore?: any;
}
export const LabelText = styled.div<ILabelText>`
  position: absolute;
  ${(props) => {
    if (props.positions === "bottom") {
      return "bottom: -9rem; transform: translateX(-50%) translateY(5rem);";
    } else {
      return "bottom: 5.5rem; transform: translateX(-50%) translateY(-5rem);";
    }
  }}
  background: #fff;
  border-radius: 2rem;
  box-shadow: 0px 10px 60px rgba(34, 24, 0, 0.1);
  box-sizing: border-box;
  left: ${(props) => (props.left ? props.left + ";" : "9.7rem;")};
  opacity: 0;
  padding: 2rem;
  transition: 0.5s;
  visibility: hidden;
  width: ${(props) => (props.width ? props.width + ";" : "30rem;")};
  ::before {
    background: #fff;
    content: "";
    height: 2rem;
    position: absolute;
    width: 2rem;
    ${(props) =>
      props.positions === "bottom" ? "top: -1rem;" : "bottom: -1rem;"}
    left: ${(props) => (props.leftBefore ? props.leftBefore + ";" : "5.5rem;")};
    transform: rotate(100deg);
  }
`;

export const DivLi = styled.div`
  border-radius: 50%;
  cursor: pointer;
  height: 2rem;
  list-style: none;
  position: relative;
  transition: 0.5s;
  width: 2rem;
  &:hover {
    ${LabelText} {
      visibility: visible;
      opacity: 1;
      transform: translateX(-123%) translateY(30%);
      z-index: 1001;
    }
  }
`;

interface IGrayBox {
  height?: string;
  disableOutline?: any;
  width?: string;
}
export const GrayBox = styled.div<IGrayBox>`
  ${(props) => `
   background-color: ${props.theme.colors.backgroundGray2};
   border: none;
   color: ${props.theme.colors.blackTextTitle};
   height: ${props.height ? props.height : "4.5rem"};
   outline: ${props.disableOutline ? "none" : ""};
   width: ${props.width};
 `}
  align-items: center;
  border-radius: 0.8rem;
  display: flex;
  font-size: 10.5px;
  font-weight: 500;
  padding: 1.5rem;
`;

interface IDivCompanyDirection {
  width?: string;
  marginLeft?: string;
  marginTop?: string;
}
export const DivCompanyDirection = styled.div<IDivCompanyDirection>`
  ${(props) => `
   width: ${props.width ? props.width : "25.6rem"};
   margin-left: ${props.marginLeft ? props.marginLeft : "2rem"};
   margin-top:  ${props.marginTop ? props.marginTop : "1rem"};
 `}
`;

interface IDivUserMenu {
  marginBottom?: string;
  marginLeft?: string;
  marginTop?: string;
  disabled?: boolean;
}
export const DivUserMenu = styled.div<IDivUserMenu>`
  ${(props) => `
   margin-bottom: ${props.marginBottom ? props.marginBottom : "0rem"};
   margin-left: ${props.marginLeft ? props.marginLeft : "1.5rem"};
   margin-top:  ${props.marginTop ? props.marginTop : "1.5rem"};
   cursor: ${props.disabled ? "not-allowed" : "pointer"}; ;
 `}
 &:disabled,
  &[disabled] {
    cursor: not-allowed;
`;

interface IDivUserMenuLabel {
  fontSize?: string;
  fontWeight?: string | number;
  marginLeft?: string;
}
export const DivUserMenuLabel = styled.div<IDivUserMenuLabel>`
  ${(props) => `
  font-family: ${props.theme.fontFamilies.primaryFont};
  font-size: ${props.fontSize ? props.fontSize : "1.4rem"};
  font-weight: ${props.fontWeight ? props.fontWeight : "600"};
  margin-left: ${props.marginLeft ? props.marginLeft : "1.5rem"};
 `}
`;

interface IDivHeader {
  dataUser?: any;
}
export const DivHeader = styled.div<IDivHeader>`
  ${(props) => `
font-family: ${props.theme.fontFamilies.primaryFont};
margin-top: ${props.dataUser ? "0rem" : "1.5rem"};
  .margin-top-left-position {
    margin-left: 2rem;
    position: absolute;
  }
  .font-weight-color {
    color: #08082B;
    font-family: Montserrat;
    font-size: 1.4rem;
    font-weight: 500;
    margin-top: -1rem;
  }

 `}
  margin-left: -2rem;
`;
export const H1Header = styled.h1`
  font-size: 2.3rem;
  font-weight: 800;
`;

export const DivOverMaxHeigth = styled.div`
  max-height: 58vh;
  overflow-x: hidden;
  overflow-y: auto;

  @media (max-height: 400px) {
    max-height: 45vh;
  }
`;
